import { SetState, GetState } from 'zustand';
import { httpService } from '../services/http.service';
import { BASE_URL } from '../constants/endpoints';
import { ICategory, IUncategorizedTransactions, IUncategorizedTransactionsData } from '../types';

export interface IUncategorizedTransactionsSlice {
    uncategorizedTotalNumOfRecords: number,
    getUncategorizedTotalNumOfRecords: () => number,
    setUncategorizedTotalNumOfRecords: (uncategorizedTotalNumOfRecords: number) => void,
    uncategorizedTransactionsList: IUncategorizedTransactions;
    uncategorizedTransactionsData: IUncategorizedTransactionsData;
    transactionCategories: ICategory[];
    setUncategorizedTransactionsList: (uncategorizedTransactionsList: IUncategorizedTransactions) => void;
    setUncategorizedTransactionsData: (uncategorizedTransactionsData: IUncategorizedTransactionsData) => void;
    setTransactionCategories: (TransactionCategories: ICategory[]) => void;
    getUncategorizedTransactionsList: () => IUncategorizedTransactions;
    getUncategorizedTransactionsData: () => IUncategorizedTransactionsData;
    getTransactionCategories: () => ICategory[];
    loadMoreTransactions: (customerId: string, queryParams: string) => Promise<void>;
    splitTransactionBusinessPercent: number | null;
    setSplitTransactionBusinessPercent: (businessPercent: number | null) => void;
    triggeredActionType: string;
    setTriggeredActionType: (actionType: string) => void;
    resetUncategorizedTransactionsSlice: () => void;
}

const createUncategorizedTransactionsSlice = (set: SetState<IUncategorizedTransactionsSlice>, get: GetState<IUncategorizedTransactionsSlice>) => ({
  uncategorizedTotalNumOfRecords: -1,
  uncategorizedTransactionsList: {
    endDate: '',
    numOfTransactions: 0,
    page: 0,
    startDate: '',
    transactionList: [],
    uncategorizedTotalNumOfRecords: 0,
  },
  uncategorizedTransactionsData: {
    dates: '',
    externalId: '',
    quarter: '',
  },
  transactionCategories: [],
  splitTransactionBusinessPercent: null,
  triggeredActionType: '',
  resetUncategorizedTransactionsSlice: () => {
    set({
      uncategorizedTotalNumOfRecords: -1,
      uncategorizedTransactionsList: {
        endDate: '',
        numOfTransactions: 0,
        page: 0,
        startDate: '',
        transactionList: [],
        uncategorizedTotalNumOfRecords: 0,
      },
      uncategorizedTransactionsData: {
        dates: '',
        externalId: '',
        quarter: '',
      },
      transactionCategories: [],
      splitTransactionBusinessPercent: null,
      triggeredActionType: '',
    });
  },
  setUncategorizedTotalNumOfRecords: (uncategorizedTotalNumOfRecords:number) => { set({ uncategorizedTotalNumOfRecords }); },
  getUncategorizedTotalNumOfRecords: () => get().uncategorizedTotalNumOfRecords,
  getUncategorizedTransactionsList: () => get().uncategorizedTransactionsList,
  setUncategorizedTransactionsList: (uncategorizedTransactionsList: IUncategorizedTransactions) => { set({ uncategorizedTransactionsList }); },
  getUncategorizedTransactionsData: () => get().uncategorizedTransactionsData,
  setUncategorizedTransactionsData: (uncategorizedTransactionsData: IUncategorizedTransactionsData) => { set({ uncategorizedTransactionsData }); },
  setTransactionCategories: (transactionCategories: any) => { set({ transactionCategories }); },
  getTransactionCategories: () => get().transactionCategories,
  loadMoreTransactions: async (customerId: string, queryParams: string) => {
    const { data } = await httpService.get((`${BASE_URL}/api/v2/user/${customerId}/home/uncategorized?${queryParams}`));
    set({
      uncategorizedTransactionsList: data,
    });
  },
  setSplitTransactionBusinessPercent: (businessPercent: number | null) => { set({ splitTransactionBusinessPercent: businessPercent }); },
  setTriggeredActionType: (actionType: string) => { set({ triggeredActionType: actionType }); },
});

export default createUncategorizedTransactionsSlice;
